import { sqWorkbenchStore, sqWorksheetStore } from '@/core/core.stores';
import { AgGridModules } from '@/core/tableUtilities/tableUtilities.types';
import { isSystemTest } from '@/core/utilities';
import { TIME_FORMAT_NUMERICAL_LONG, formatTime } from '@/datetime/dateTime.utilities';
import { getPreferredTimeFormat } from '@/datetime/dateTimeFormatting.utilities';
import { DEFAULT_AG_GRID_PROPS as BASE_AG_GRID_PROPS, createGridDateTimeDataTypeDefinitions } from '@seeqdev/ag/grid';
import type { AgGridAsyncProps } from '@/core/tableUtilities/tableUtilities.types';
import type { AnyProperty } from '@/utilities.types';
import type { DataTypeDefinition } from '@seeqdev/ag/grid';

// The lazy-loading counterpart of @seeqdev/ag's COMMON_AG_GRID_MODULES preset: AgGridAsync resolves these enum names
// to dynamic imports so consumers do not bundle every AG module eagerly.
export const COMMON_AG_GRID_MODULES = [
  AgGridModules.SetFilterModule,
  AgGridModules.ColumnMenuModule,
  AgGridModules.ContextMenuModule,
  AgGridModules.ColumnsToolPanelModule,
  AgGridModules.RowAutoHeightModule,
  AgGridModules.RowStyleModule,
  AgGridModules.PaginationModule,
  AgGridModules.RowDragModule,
  AgGridModules.RowNumbersModule,
  AgGridModules.PinnedRowModule,
  AgGridModules.RowSelectionModule,
  AgGridModules.RowApiModule,
  AgGridModules.TextFilterModule,
  AgGridModules.DateFilterModule,
  AgGridModules.NumberFilterModule,
  AgGridModules.MultiFilterModule,
  AgGridModules.CustomFilterModule,
  AgGridModules.LocaleModule,
  AgGridModules.TooltipModule,
  AgGridModules.ColumnAutoSizeModule,
];

export const CUSTOM_TYPE_DEFINITIONS: AnyProperty<DataTypeDefinition> = createGridDateTimeDataTypeDefinitions({
  formatDateTime: (value) =>
    formatTime(value, sqWorksheetStore.timezone, getPreferredTimeFormat(sqWorkbenchStore.use24HourFormat)),
  formatDateTimeWithSeconds: (value) =>
    formatTime(
      value,
      sqWorksheetStore.timezone,
      getPreferredTimeFormat(sqWorkbenchStore.use24HourFormat, TIME_FORMAT_NUMERICAL_LONG),
    ),
});

/**
 * Suppress row virtualisation in test environments to avoid 0x0 grid elements not working with horizontal scrolling
 * (`ensureColumnVisible`, for example)
 */
export const shouldSuppressAgGridVirtualisation = (): boolean => isSystemTest() || process.env.NODE_ENV === 'test';

export const DEFAULT_AG_GRID_PROPS: AgGridAsyncProps = {
  ...BASE_AG_GRID_PROPS,
  modules: COMMON_AG_GRID_MODULES,
  suppressColumnVirtualisation: shouldSuppressAgGridVirtualisation(),
  suppressRowVirtualisation: shouldSuppressAgGridVirtualisation(),
  dataTypeDefinitions: CUSTOM_TYPE_DEFINITIONS,
};

export const EXTRA_TOPIC_PROPS = { getChartToolbarItems: () => [] };

export const EXTRA_NON_TOPIC_PROPS = {};
